import type { ClipboardData } from '@/models/clipboard/ClipboardData';
import { CircuitType } from '@/schemas/common';
import { TileType } from '@/models/TileTypes';
import { setupDefaultMeta } from '@/models/tiles/TileInstance';
import { isInterfaceTileDefinition } from '@/models/tiles/TileDefinition';
import { tileDefinitionRegistry } from '@/models/tiles/TileRegistry';

/** Structure paste uses the selection's footprint, never its logic or nested instances. */
export function clipboardForCircuit(
  data: ClipboardData,
  circuitType: CircuitType,
  adapter = false,
): ClipboardData {
  if (circuitType !== CircuitType.ChipStructure) return data;
  const isInterface = (type: TileType) =>
    adapter
      ? type === TileType.SingleInterface || type === TileType.BundleInterface
      : isInterfaceTileDefinition(tileDefinitionRegistry.get(type));
  if (
    !data.chipInstances.length &&
    !data.connections.length &&
    !data.edgeHints.length &&
    !data.disconnected?.length &&
    data.tiles.every(
      (entry) =>
        !entry.meta.partOfChip &&
        (entry.tileType === TileType.Structure || isInterface(entry.tileType)),
    )
  )
    return data;
  return {
    ...data,
    chipInstances: [],
    connections: [],
    edgeHints: [],
    disconnected: [],
    tiles: data.tiles.map((entry) => {
      if (isInterface(entry.tileType) || entry.tileType === TileType.Structure) {
        return { ...entry, meta: { ...entry.meta, partOfChip: null } };
      }
      return {
        tileType: TileType.Structure,
        relativeLocation: { ...entry.relativeLocation },
        meta: {
          ...setupDefaultMeta(),
          ...(entry.meta.tint ? { tint: entry.meta.tint } : {}),
        },
      };
    }),
  };
}
